import { useQuery } from "react-query";

import { useOrg } from "@hooks/useOrg";

import { fetchPolicy } from "@pages/policy/api";

/*
 * Returns query result with policy (and rulesets) from current selected org
 */
export const usePolicy = (policySlug: string) => {
  const org = useOrg();

  return useQuery(
    ["policy", { org, policySlug }],
    () => fetchPolicy(org?.id!, policySlug),
    {
      enabled: !!org,
    }
  );
};
